module.exports = __webpack_public_path__ + "static/media/sendMessage.97e8df77.svg";